export default __webpack_public_path__ + "static/media/44.dc89ed06.jpeg";